<template>
  <div class="child-list-item border">
    <div class="row text-center">
      <div class="col-12 d-flex justify-content-center">
        <child-thumbnail :key="child.id" :child="child" style="margin-top: 15px"></child-thumbnail>
      </div>
      <div class="col-12">
        <router-link :to="'/children/' + child.id">
          <h3>{{ child.first_name }}</h3>
          <p>{{ child.last_name_suffix }} {{ child.last_name }}</p>
        </router-link>
        <hr>
      </div>
      <div class="col-12 d-flex justify-content-center align-self-center" style="margin-top: 10px">
        <div v-if="child.status && child.status.activities && child.status.activities.length > 0" style="display: inline-block">
          <div v-bind:key="activity.id" v-for="activity in child.status.activities">
            <activity-icon :id="activity.icon_id" :height="'40px'"></activity-icon>
            <div style="margin-top: 7px; padding-left: 5px; padding-right: 5px; display: inline-block; border-radius: 12px; background-color: #8e70d3; border: 2px solid #765cae; color: white; font-size: 12px; margin-left: 5px; margin-right: 5px">
                {{ activity.start_time.substr(0, 5) }}
              <span v-if="activity.end_time">
              <span class="d-none d-sm-inline">
                  -
              </span>
                {{ activity.end_time.substr(0, 5) }}
              </span>
            </div>
            <span v-on:click="onEdit(activity)">
              <icon name="edit"></icon>
            </span>
            <p>
              {{ activity.text || activity.activity }}
            </p>
          </div>
        </div>
        <div v-else>
          <p class="text-muted" style="margin-top: -7px">
            Geen activiteit
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChildThumbnail from '@/components/Child-Thumbnail'
import ActivityIcon from '@/components/Activity-Icon'
import Icon from '@/components/Icon'
export default {
  name: 'child-list-item',
  props: ['child'],
  components: {
    ChildThumbnail,
    ActivityIcon,
    Icon
  },
  methods: {
    onEdit (activity) {
      this.$emit('editActivity', activity)
    }
  }
}
</script>

<style scoped>
  h3 {
    margin-top: 4px;
    margin-bottom: 0;
  }
  p {
    margin-bottom: 0;
  }
  a {
    color: #666;
  }
</style>
